/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */

'use strict';
angular
  .module('http.billing', ['ngCookies'])
  /**
   * Service used to access all calls to the billing rest service.
   */
  .factory('httpBilling', function ($http, $cookies) {
    /**
     * Get the billing info for the account.
     *
     * @returns {promise} A promise that when resolved will include a billing info object.
     */
    var getBillingInfo = function () {
      return $http({
        method: 'GET',
        url: 'api/billing/info'
      })
        .then(function (res) {
          return res.data;
        })
        .catch(() => ({ priceQuote: {} }));
    };

    /**
     * Get the billing email for the account.
     *
     * @returns {promise} A promise that when resolved will include a billing email.
     */
    var getBillingEmail = function () {
      return $http({
        method: 'GET',
        url: 'api/billing/email'
      }).then(function (res) {
        return res.data;
      });
    };

    /**
     * Update the billing email setting for the organization.
     *
     * @returns {promise} A promise that when resolved will include an object.
     */
    var updateBillingEmail = function (address) {
      return $http({
        method: 'POST',
        url: 'api/billing/email',
        data: {
          billingEmailAddress: address
        }
      }).then(function (res) {
        return res.data;
      });
    };

    /**
     * Gets the HTML fragment used to display a receipt.
     *
     * @param {Number} transactionId - The id of the transaction.
     * @returns {Promise} A promise that resolves to the HTML fragment for displaying a receipt.
     */
    var getReceiptContent = function (transactionId) {
      return $http({
        method: 'GET',
        url: 'api/billing/receipt-content/' + transactionId
      }).then(function (res) {
        return res.data;
      });
    };

    /**
     * Get the extra receipt info.
     * @returns {Promise} A promise that will resolve to an object with the receiptInfo property.
     */
    var getExtraInfo = function () {
      return $http({
        method: 'GET',
        url: 'api/billing/receipt-info'
      }).then(function (res) {
        return res.data;
      });
    };

    /**
     * Update extra receipt info setting for org.
     * @returns {Promise} A promise that will resolve after update is complete.
     */
    var updateExtraInfo = function (extraInfo) {
      return $http({
        method: 'POST',
        url: 'api/billing/receipt-info',
        data: {
          receiptInfo: extraInfo
        }
      });
    };

    /**
     * Delete the extra receipt info setting for org.
     * @returns {Promise} A promise that will resolve after update is complete.
     */
    var deleteExtraInfo = function () {
      return $http({
        method: 'DELETE',
        url: 'api/billing/receipt-info'
      });
    };

    /**
     * Get a list of transactions.
     * @returns {Promise} A promise that will resolve to a list of transactions.
     */
    var getTransactions = function () {
      return $http({
        method: 'GET',
        url: 'api/billing/transactions'
      }).then(function (res) {
        return res.data;
      });
    };

    /**
     * Validates tax address
     * @param taxAddress
     * @returns {Promise} A promise that will resolve after validation is complete.
     */
    var validateTaxAddress = function (taxAddress) {
      return $http({
        method: 'POST',
        url: 'api/billing/validate-address',
        data: { taxAddress: taxAddress }
      }).then(function (res) {
        return res.data;
      });
    };

    return {
      deleteExtraInfo: deleteExtraInfo,
      getBillingInfo: getBillingInfo,
      getBillingEmail: getBillingEmail,
      updateBillingEmail: updateBillingEmail,
      getExtraInfo: getExtraInfo,
      getReceiptContent: getReceiptContent,
      getTransactions: getTransactions,
      updateExtraInfo: updateExtraInfo,
      validateTaxAddress: validateTaxAddress
    };
  });
